import { BASE_URL } from './config';
import { buildScopedApiParams, resolveWorkspace } from './workspace/workspaceScope';

const normalizeBaseUrl = (value) => String(value || '').trim().replace(/\/+$/, '');

function configuredRoutes() {
  const routes = { 'BITGET:PERPS': BASE_URL };
  const raw = process.env.REACT_APP_TRADE_SERVICE_ROUTES;
  if (!raw) return routes;

  try {
    const configured = JSON.parse(raw);
    if (!configured || Array.isArray(configured) || typeof configured !== 'object') {
      throw new Error('Trade service routes must be an object');
    }
    Object.entries(configured || {}).forEach(([scope, baseUrl]) => {
      const normalizedUrl = normalizeBaseUrl(baseUrl);
      if (normalizedUrl) routes[String(scope).trim().toUpperCase()] = normalizedUrl;
    });
    return routes;
  } catch (error) {
    throw new Error('REACT_APP_TRADE_SERVICE_ROUTES must be a valid JSON object');
  }
}

export function resolveTradeServiceBaseUrl(scope) {
  const workspace = resolveWorkspace(scope);
  if (!workspace.exchange || !workspace.marketType) {
    throw new Error('Exchange and market type are required for trading');
  }

  const routes = configuredRoutes();
  const scopedRoute = routes[`${workspace.exchange}:${workspace.marketType}`];
  const exchangeRoute = routes[workspace.exchange];
  const baseUrl = normalizeBaseUrl(scopedRoute || exchangeRoute);
  if (!baseUrl) {
    throw new Error(
      `No trade service is configured for ${workspace.exchange} / ${workspace.marketType}`
    );
  }
  return baseUrl;
}

export function buildTradeServiceUrl(path, scope, params = {}) {
  const baseUrl = resolveTradeServiceBaseUrl(scope);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const query = buildScopedApiParams(scope, params).toString();
  return `${baseUrl}${normalizedPath}${query ? `?${query}` : ''}`;
}
